 
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { QCUploadEDTF } from '@dynamika-shared/types/ImagingSpecialist';
import { createSelector, createSliceHook, makeActionCreator } from '@restore/helpers';

type EDTFState = {
  loading: boolean;
  data: QCUploadEDTF | null;
  error?: string;
  uploadId: string;
};

const initialState: EDTFState = {
  loading: false,
  data: null,
  uploadId: '',
};

export type FetchAction = PayloadAction<{
  clinicalTrialId: string;
  taskId: string;
  uploadId: string;
}>;

const { actResolve, act, actReject, actEmpty } = makeActionCreator<EDTFState>();

export const EDTFSlice = createSlice({
  name: 'EDTF',
  initialState,
  reducers: {
    openEDTF: actEmpty<{ clinicalTrialId: string; taskId: string; uploadId: string }>(),
    fetchEDTF: act<FetchAction['payload']>(({ uploadId }) => ({
      loading: true,
      uploadId,
    })),
    fetchEDTFSuccess: actResolve<QCUploadEDTF>(),
    fetchEDTFFailure: actReject(),
    reset: act(() => ({
      data: null,
    })),
  },
});

export const selectEDTFState = createSelector(EDTFSlice.name);

export const useEDTFSlice = createSliceHook(EDTFSlice.name, EDTFSlice.actions);
